import moment from 'moment-timezone';
class Demand{
  tzDay;
  avgOccupied;
  avgOccupiedPer;
  maxOccupiedPer;
  maxOccupied;
  minFree;
  minFreePer;
  unused;
  unusedPer;
  total_count;

  constructor(tzDay, avgOccupied,avgOccupiedPer,maxOccupiedPer,maxOccupied,minFree,minFreePer,unused,unusedPer,total_count){
    this.tzDay = tzDay;
    this.avgOccupied=avgOccupied;
    this.avgOccupiedPer=avgOccupiedPer;
    this.maxOccupied=maxOccupied;
    this.maxOccupiedPer=maxOccupiedPer;
    this.minFree = minFree;
    this.minFreePer = minFreePer;
    this.unused = unused;
    this.unusedPer = unusedPer;
    this.total_count = total_count;
    // this.day = moment(tzDay).day();
  }

  static fromJSON(store, json) {
    const { tzDay, avgOccupied,avgOccupiedPer,maxOccupied,maxOccupiedPer,minFree,minFreePer,unused,unusedPer,total_count } = json;
    return new Demand (tzDay, avgOccupied,avgOccupiedPer,maxOccupied,maxOccupiedPer,minFree,minFreePer,unused,unusedPer,total_count);
  }

}
export default Demand;
